import PlainInputSearch, { type PlainInputSearchProps } from './plain-input-search'

export default PlainInputSearch

export type { PlainInputSearchProps }
